module.exports = __webpack_public_path__ + "static/img/gasMonitor_active.1d41bfc4.png";